import {ShapeCommand} from '../commands.template';

export class ImageDeleteCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;

  constructor(data) {
    super(data);
    // this.firstAction = true;
  }

  public execute() {
    super.execute();
    // if (this.firstAction) {
    //   this.firstAction = false;
    //   return this.executeJson(this.object);
    // }
    const graph = this.services.editorRegistrySvc.getGraph();
    const imageVertex = this.services.graphHelperSvc
      .allImages()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    graph.removeCells([imageVertex], false);

    return this.executeJson(this.object);
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteImage: {mxKey: Number(data.mxKey)}
    });
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const imageVertex = this.services.shapeSpawnerSvc.createImage(
      this.object,
      this.object.imageResized
    );

    graph.addCell(imageVertex, this.services.graphHelperSvc.imageParent());

    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      createImage: {
        mxKey: Number(data.mxKey),
        position: {
          x: data.position.x,
          y: data.position.y,
          w: data.position.w,
          h: data.position.h,
          r: data.position.r
        },
        uuid: data.uuid,
        locked: Boolean(data.locked),
        link: data.link
      }
    });
  }
}
